import React from 'react'

import { Header, Loader } from 'components'
import { Page } from 'common'

import { UnavailableServiceView } from './UnavailableServiceView'
import { useUnavailableService } from '../hooks/useUnavailableService'

export function UnavailableService() {
  const { onClose, confirmButton, details, icon, title, goTo, isLoading, isError } =
    useUnavailableService()

  if (isLoading) return <Loader />

  if (isError) return null

  return (
    <Page>
      <Header title="" goToPath={goTo} />
      <UnavailableServiceView
        icon={icon}
        title={title ?? ''}
        details={details ?? ''}
        label={confirmButton ?? ''}
        onClose={onClose}
      />
    </Page>
  )
}
